exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".carousel-3d-container[data-v-2d7d48c0]{overflow:visible!important}.backLogo[data-v-2d7d48c0]{position:relative;display:block;float:left;opacity:.1;background-size:contain;width:350px;height:350px}.backLogoDiv[data-v-2d7d48c0]{width:100%;position:absolute;bottom:0}#carouselMain-img[data-v-2d7d48c0]{height:100%!important;width:100%!important;background-size:cover!important}#logo-img[data-v-2d7d48c0]{margin-top:20%;height:100%!important;width:100%!important;background-size:contain!important}#playArrow[data-v-2d7d48c0]{height:100%;width:100%;font-size:10em;margin:auto;cursor:pointer;text-shadow:6px 6px 10px rgba(0,0,0,.5);-webkit-transition:color .5s ease;transition:color .5s ease}#carMargin[data-v-2d7d48c0]{margin-top:5%}#descriptSize[data-v-2d7d48c0]{max-width:55%!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2d7d48c0","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Category.vue
// module id = 633
// module chunks = 0